import pl from "@locales/schedule/pl.json";
import en from "@locales/schedule/en.json";

export default {
  pl,
  en,
};
